import classNames from "classnames";
import React, { useContext, useEffect } from "react";
import { useConverters } from "./../../pm-converters/context";
import { TIPTAP_CAPTION_TYPE } from "./../../ricos-content";
import { PluginsEventsContext, RicosContext, usePluginExportsContext } from "./../../ricos-context";
import { Node_Type } from "./../../ricos-types";
import { isNodeSelected } from "./../../_shared/is-node-selected";
import { getPluginContainerClassNames, getPluginFocusClassNames } from "./../../_shared/node-styles";
import { CAPTION } from "../data-hooks";
import classes from "./caption-scss";
import { useEditorSelection } from "./use-editor-selection";
const Caption = ({ NodeViewContent, editor, node }) => {
  const { isMobile } = useContext(RicosContext);
  const pluginsEvents = useContext(PluginsEventsContext);
  const pluginExports = usePluginExportsContext();
  const selectedNodes = useEditorSelection(editor).selectedNodes;
  const captionNodePos = editor.$doc.querySelector(TIPTAP_CAPTION_TYPE, {
    id: node.attrs.id
  });
  const converters = useConverters();
  if (!captionNodePos?.parent?.node) {
    console.error("Caption must have a parent.");
    return null;
  }
  const ricosParentNode = converters.fromPmNode(captionNodePos.parent.node.toJSON());
  const AiButton = pluginExports.aiIntegrations?.image?.captionTrigger;
  const isCaptionSelected = selectedNodes.find(
    (selectedNode) => selectedNode.attrs.id === node.attrs?.id
  );
  const isParentSelected = selectedNodes.find(
    (selectedNode) => selectedNode.attrs.id === ricosParentNode?.id
  );
  useEffect(() => {
    if (node.content.firstChild?.text || isCaptionSelected || isParentSelected) {
      return;
    }
    pluginsEvents?.publishPluginLayoutShift({ nodeId: node.attrs.id });
  }, [isCaptionSelected, isParentSelected]);
  const isVisible = isCaptionSelected || isParentSelected || !!node.content.firstChild;
  const hasAiButton = isCaptionSelected && ricosParentNode?.type === Node_Type.IMAGE && AiButton;
  const isFocused = isNodeSelected(editor.state, node.attrs.id);
  const className = classNames(
    classes.caption,
    getPluginContainerClassNames(isMobile),
    getPluginFocusClassNames(isFocused)
  );
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className,
      style: isVisible ? void 0 : {
        display: "none"
      }
    },
    hasAiButton ? /* @__PURE__ */ React.createElement("div", { className: classes.aiButtonContainer }, /* @__PURE__ */ React.createElement(
      AiButton,
      {
        node: ricosParentNode,
        onCaptionChange: (caption) => {
          const { range } = captionNodePos;
          const { tr } = editor.state;
          tr.insertText(caption, range.from, range.to);
          editor.view.dispatch(tr);
        }
      }
    )) : null,
    /* @__PURE__ */ React.createElement(
      NodeViewContent,
      {
        dir: "auto",
        "data-hook": CAPTION,
        as: "figcaption",
        style: {
          width: "100%",
          overflow: "auto",
          lineHeight: node.attrs?.textStyle?.lineHeight,
          textAlign: node.attrs?.textStyle?.textAlignment,
          paddingTop: node.attrs?.style?.paddingTop ?? node.attrs?.styleDefaults?.paddingTop,
          paddingBottom: node.attrs?.style?.paddingBottom ?? node.attrs?.styleDefaults?.paddingBottom
        }
      }
    )
  );
};
export {
  Caption
};
//# sourceMappingURL=caption.js.map
